import React, { useState, useEffect } from 'react';
import { heroFadeStyle } from './utils/heroFade';
import tokenBanner from './assets/images/tokenBanner.webp';
import { useT } from './i18n';

const PILLARS = [
  { key: 'heroToken.collateral', value: 'heroToken.collateralValue' },
  { key: 'heroToken.yield', value: 'heroToken.yieldValue' },
  { key: 'heroToken.utility', value: 'heroToken.utilityValue' },
];

const HeroToken = () => {
  const t = useT();
  const [, setLoading] = useState(true);

  useEffect(() => {
    const img = new Image();
    img.src = tokenBanner;
    img.onload = () => setLoading(false);
  }, []);

  const backgroundImageStyle = {
    backgroundColor: '#000000',
    backgroundImage: `url(${tokenBanner})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    ...heroFadeStyle,
  };

  return (
    <section className="relative flex w-full items-center overflow-hidden">
      {/* Artwork layer, faded at the bottom so the hero dissolves into the page. */}
      <div aria-hidden="true" className="absolute inset-0" style={backgroundImageStyle}>
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/75 to-black/25" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-transparent to-black/50" />
      </div>

      <div className="relative mx-auto w-full max-w-screen-2xl px-4 py-16 sm:px-8 md:min-h-[520px] md:py-20 lg:px-10">
        <div className="max-w-2xl lb-animate-in">
          <span className="lb-chip lb-chip-cyan">
            <span className="lb-dot" aria-hidden="true" />
            {t('heroToken.badge')}
          </span>

          <h1 className="lb-heading mt-6 text-[2.25rem] leading-[0.98] sm:text-5xl lg:text-6xl">
            <span className="lb-gradient-text">C.R.A.N.N.I</span>
            <span className="mt-1 block text-2xl sm:text-3xl lg:text-4xl">
              {t('heroToken.subtitle')}
            </span>
          </h1>

          <p className="mt-6 max-w-xl font-medium text-base leading-relaxed text-white/80 sm:text-lg">
            {t('heroToken.body')}
          </p>

          <dl className="mt-9 grid max-w-xl grid-cols-1 gap-3 sm:grid-cols-3">
            {PILLARS.map((item) => (
              <div
                key={item.key}
                className="rounded-2xl border border-white/10 bg-black/50 px-4 py-3 backdrop-blur"
              >
                <dt className="lb-label">{t(item.key)}</dt>
                <dd className="mt-1 text-sm font-semibold text-white">{t(item.value)}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
};

export default HeroToken;
